import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { buscarAsesores, buscarCitas, filtarCitas } from '../../actions/deportiva';

const FiltrosCitas = () => {

    const dispatch =  useDispatch();

    const { listado_asesores, ventana_filtros } = useSelector(state => state.deportiva);

    const [statusProcesar, setStatusProcesar] = useState(false);

    const [filtrosData, setFiltrosData] = useState({
        tipo: null,
        id_asesor: null, 
        status: null,
        fecha_inicio: null,
        fecha_fin: null
    });

    const [tipoData, setTipoData] = useState(null);
    const tiposFilter = [
        { value: 0, label: 'Cita' }, 
        { value: 1, label: 'Bloqueo' }
    ];

    const [asesorData, setAsesorData] = useState(null);
    const [asesoresFilter, setAsesoresFilter] = useState([]);

    const [statusData, setStatusData] = useState(null);
    const statusFilter = [
        { value: 0, label: 'Pendiente' }, 
        { value: 1, label: 'Autorizada' }, 
        { value: 2, label: 'Rechazada' }
    ];

    /* Filtros */
    const handleAbrir = () => {
        dispatch(buscarAsesores());
    }

    const handleSelectTipo = (option) => {
        setTipoData(option);

        setFiltrosData({
            ...filtrosData,
            tipo: option != null ? option.value : null
        });
    }

    const handleSelectAsesor = (option) => {
        setAsesorData(option);

        setFiltrosData({
            ...filtrosData,
            id_asesor: option != null ? option.value : null
        });
    }

    const handleSelectStatus = (option) => {
        setStatusData(option);

        setFiltrosData({
            ...filtrosData,
            status: option != null ? option.value : null
        });
    }

    const handleDatePicker = (name, value) => {
        setFiltrosData({
            ...filtrosData,
            [name]: value
        });
    }
    
    const handleProcesar = async (limpiar) => {
        await setStatusProcesar(true);

        if(!limpiar){
            await dispatch(buscarCitas(filtrosData));
        }else{
            let datos_base = {
                ...filtrosData, 
                tipo: null,
                id_asesor: null, 
                status: null,
                fecha_inicio: null,
                fecha_fin: null
            };

            await dispatch(buscarCitas(datos_base));

            await setFiltrosData(datos_base);

            await setTipoData(null);
            await setAsesorData(null);
            await setStatusData(null);
        }

        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            dispatch(filtarCitas(false));
        }
    }

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_asesores.length; i++) {
            options.push({ value: listado_asesores[i]._id, label: [listado_asesores[i].nombre, listado_asesores[i].apellido_paterno, listado_asesores[i].apellido_materno].join(' ') });
        }

        setAsesoresFilter(options);
    }, [listado_asesores]);

    return (
        <Modal show={ventana_filtros} size="lg" backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Filtrar citas y bloqueos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="tipo"
                                name="tipo"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar tipo"
                                isClearable
                                options={tiposFilter}
                                value={tipoData}
                                onChange={(value) => handleSelectTipo(value)}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>
                    </div>

                    <div className="col-md-8 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="id_asesor"
                                name="id_asesor"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar asesor"
                                isClearable
                                options={asesoresFilter}
                                value={asesorData}
                                onChange={(value) => handleSelectAsesor(value)}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="status"
                                name="status"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar status"
                                isClearable
                                options={statusFilter}
                                value={statusData}
                                onChange={(value) => handleSelectStatus(value)}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_inicio"
                                    name="fecha_inicio"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    selected={ filtrosData.fecha_inicio != null ? new Date(filtrosData.fecha_inicio) : '' }
                                    onChange={ date => handleDatePicker('fecha_inicio', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha_inicio">Inicio de creación</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_fin"
                                    name="fecha_fin"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    selected={ filtrosData.fecha_fin != null ? new Date(filtrosData.fecha_fin) : '' }
                                    onChange={ date => handleDatePicker('fecha_fin', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha_fin">Fin de creación</label>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <>
                            <button type="button" className="btn btn-primary" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Buscar todos</button>
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Buscar</button>
                        </>
                    :
                        <>
                            <button type="button" className="btn btn-primary" onClick={() => handleProcesar(true)}><i className="fas fa-search fa-sm"></i> Buscar todos</button>
                            <button type="button" className="btn btn-success" onClick={() => handleProcesar(false)}><i className="fas fa-search fa-sm"></i> Buscar</button>
                        </>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default FiltrosCitas;